<template>
  <PageContainer type="bg2">
    <div class="user">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="12" :md="8" class="dashboard-card">
          <el-card shadow="always">
            <p>社員編號：<span>{{ userInfo.profile.memberNumber }}</span></p>
            <p>姓名：<span>{{ userInfo.profile.name }}</span></p>
            <p>手機：<span>{{ userPhone }}</span></p>
            <p>入股股金：<span>{{ userInfo.totalCapital || 0 }}</span></p>
            <p>購買金額(月結)：<span>{{ userInfo.totalOrderPrice || 0 }}</span></p>
            <p>購物金(介紹)：<span>{{ userInfo.profile.shopMoney || 0 }}</span></p>
            <p>購物回潤金：<span>{{ userInfo.profile.returnMoney || 0 }}</span></p>
            <p>分紅錢包：<span>{{ 0 }}</span></p>
            <p>
              直接介紹：
              <span class="text-button" @click="levelDialogVisible = true">
                查看層級
              </span>
            </p>
            <p>
              服務列表：
              <span class="text-button" @click="secondLevelDialogVisible = true">
                查看層級
              </span>
            </p>
            <p>幣別：<span>{{ currency }}</span></p>
          </el-card>
        </el-col>
      </el-row>
      <el-dialog
        title="購買序號"
        :visible.sync="serialNumberDialogVisible"
      >
        <span slot="footer">
          <el-button type="primary" @click="handleCloseDialog">確 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="累計階段獎金"
        :visible.sync="levelCountDialogVisible"
      >
        <span slot="footer">
          <el-button type="primary" @click="handleCloseDialog">確 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="層級列表"
        class="children-dialog"
        :visible.sync="levelDialogVisible"
        :close-on-click-modal="false"
        height="430px"
      >
        <div class="user-dialog">
          <el-tree :props="props" :load="loadNode" lazy empty-text="暫無資料" />
        </div>
      </el-dialog>
      <el-dialog
        title="層級列表"
        class="children-dialog"
        :visible.sync="secondLevelDialogVisible"
        :close-on-click-modal="false"
        height="430px"
      >
        <div class="user-dialog">
          <el-tree :props="props" :load="loadSecondNode" lazy empty-text="暫無資料" />
        </div>
      </el-dialog>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
import { AccountTypeMap } from '@/utils/enum'

// const CurrencyText = {
//   TWD: '新台幣',
//   USD: '美金',
//   CNY: '人民幣'
// }

// const {
//   TWD,
//   USD,
//   CNY
// } = CurrencyText

// const CurrencyTextMap = {
//   IDENTITY_CARD: TWD,
//   TW_PASSPORT: TWD,
//   ARC: TWD,
//   UNIFORM_NUMBERS: TWD,
//   PASSPORT: USD,
//   OTHER: USD,
//   CHINA_ID_CARD: CNY
// }

export default {
  components: {
    PageContainer
  },
  data() {
    return {
      AccountTypeMap,
      stat: {},
      serialNumberDialogVisible: false,
      levelCountDialogVisible: false,
      levelDialogVisible: false,
      secondLevelDialogVisible: false,
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      }
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'userInfo']),
    userPhone() {
      const { phone } = this.userInfo.profile
      const hideIndex = [4, 5, 6]
      if (phone) {
        return phone.split('').map((number, index) => hideIndex.includes(index) ? 'x' : number).join('')
      } else {
        return '-'
      }
    },
    remainginPoints() {
      const { profile = {}} = this.userInfo || {}
      const {
        points = 0,
        recommendPoints = 0,
        pointsUsed = 0
      } = profile
      return points + recommendPoints - pointsUsed
    },
    currency() {
      // return CurrencyTextMap[this.userInfo.profile.accountType]
      return '新台幣'
    }
  },
  watch: {
    isLogin(currentValue, prevValue) {
      if (prevValue && !currentValue) {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    handleCloseDialog() {
      this.serialNumberDialogVisible = false
      this.levelCountDialogVisible = false
    },
    loadNode(node = {}, resolve) {
      const account = node.level === 0 ? this.userInfo.profile.account : node.data.account
      this.getChildrenInfo(account, resolve)
    },
    loadSecondNode(node = {}, resolve) {
      const account = node.level === 0 ? this.userInfo.profile.account : node.data.account
      this.getSecondChildrenInfo(account, resolve)
    },
    async getChildrenInfo(account, resolve = () => {}) {
      const { data = {}} = await api.user.childrenInfo({
        account
      }) || {}

      const childList = data.filter((item) => item.account !== account).map((children) => ({
        name: `${this.hiddenName(children.name.trim())}(${this.AccountTypeMap[children.accountType]})`,
        account: children.account,
        isLeaf: true
      }))

      resolve(childList)
    },
    async getSecondChildrenInfo(account, resolve = () => {}) {
      const { data = {}} = await api.user.secondRecommendChildren({
        account
      }) || {}

      const childList = data.filter((item) => item.account !== account).map((children) => ({
        name: `${this.hiddenName(children.name.trim())}(${this.AccountTypeMap[children.accountType]})`,
        account: children.account,
        isLeaf: true
      }))

      resolve(childList)
    },
    hiddenName(name = '') {
      if (!name) return ''
      const firstName = name[0]
      const lastName = name[name.length - 1]

      return `${firstName}O${lastName}`
    }
  }
}
</script>

<style lang="scss">
.user {
  width: 100%;
  p {
    font-size: 16px;
    margin-bottom: 12px;
  }
  span {
    font-weight: 600;
  }
  .text-button {
    color: $mainPurple;
    cursor: pointer;
    &--disabled {
      color: #e8e8e8;
      cursor: not-allowed;
    }
  }
  &-dialog {
    max-height: 400px;
    overflow: scroll;
    span {
      font-size: 16px;
    }
  }
  .el-card {
    border-radius: 32px;
    &.is-always-shadow {
      box-shadow: 0 2px 6px 0 $mainPurple;
    }
  }
}
.el-dialog__wrapper {
  @include minWidth992 {
    padding-right: 100px;
  }
}
.el-dialog {
  border-radius: 32px;
  box-shadow: 0 2px 6px 0 $mainPurple;
  width: 90%;
  max-width: 400px;
  min-height: 430px;
}
.el-dialog__title {
  color: $mainPurple;
  font-size: 20px;
}
.el-dialog__body {
  height: calc(100% - 127px);
}

.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
    color: $mainPurple;
}

.el-dialog__close {
  font-size: 24px;
  font-weight: 600;
  &:hover {
    color: $mainPurple;
  }
}

.el-button {
  background-color: $mainPurple;
  border: 0;
  &:hover, &:focus {
    background-color: $mainPurple;
    opacity: 0.8;
  }
}
</style>
